// Resizing the images to the exact size they will be displayed at is the most efficient
// However that causes the image to be hardly seen without opening it in full screen
// Therefore we resize it down to the max size * the factor
// This factor is not trivial and adjusted based on trial and error
const IMAGE_RESIZING_FACTOR = 2;

interface Dimensions {
  width: number | undefined;
  height: number | undefined;
}

function clampDimensions(width: number, height: number, maxWidth: number, maxHeight: number): Dimensions {
  if (width <= maxWidth && height <= maxHeight) {
    return { width, height };
  }
  const ratio = Math.min(maxWidth / width, maxHeight / height);
  return {
    width: Math.floor(width * ratio),
    height: Math.floor(height * ratio),
  };
}

function resizeToDimensions({
  width,
  height,
  maxWidth,
  maxHeight,
}: {
  width: number | undefined;
  height: number | undefined;
  maxWidth: number;
  maxHeight: number;
}): { display: Dimensions; fetch: Dimensions } {
  if (width === undefined || height === undefined) {
    return {
      display: { width: undefined, height: undefined },
      fetch: { width: undefined, height: undefined },
    };
  }

  return {
    display: clampDimensions(width, height, maxWidth, maxHeight),
    fetch: clampDimensions(width, height, maxWidth * IMAGE_RESIZING_FACTOR, maxHeight * IMAGE_RESIZING_FACTOR),
  };
}

export { resizeToDimensions };
